import { useIsComerciales } from 'src/feature-app';
import { formatSlugToTitle, removeConsecutiveDuplicates } from 'src/helpers';
import { DatoEconomicoOffer, DealersInfo, FormDataGroup, Offer } from 'src/types';
import { formatHeaders } from '../../format-fields';
import { isCallCenterForm } from '../CallCenter';
import { isOfertasForm } from '../LeadGenericoForm';
import { isOfertaV2 } from 'src/bff';

export const getOfertasData = async (formData: FormDataGroup, dealersInfo: DealersInfo) => {
	const { fields } = formData;
	const { oferta } = dealersInfo;
	const isComerciales = useIsComerciales();

	if(!oferta) return null;

	if (isOfertasForm(fields.formName) || isCallCenterForm(fields.formName)) {
		const ofertaFields = {
			'fields[VEH_INTEREST_ID]': isComerciales ? oferta.carline.code + '_' + oferta.carline.salesgroup.code : oferta.carline.code,
			'fields[VEH_INTEREST_MODEL]': removeConsecutiveDuplicates(formatSlugToTitle(isComerciales ? `${oferta.carline.nuevo ? 'Nuevo ' : ''}${oferta.carline.salesgroup.name}` : `${oferta.carline.nuevo ? 'Nuevo ' : ''}${oferta.carline.title}`)),
			'fields[VEH_INTEREST_FINANCIAL_PRODUCT]': getTipoFinanciacion(oferta),
			'fields[VEH_INTEREST_OFFER_DETAIL]': createOfferDetails(oferta),
			'fields[COMMENTS_BRAND]': getObservationBrand(oferta),
		};

		if (isOfertasForm(fields.formName)) {
			const headers = {
				FORM_NAME: 'vw-oneform-lead-oferta',
			};
			return { ...formatHeaders(headers), ...ofertaFields };
		} else {
			return { ...ofertaFields };
		}
	} else {
		return null;
	}
};

const getTipoFinanciacion = (oferta: Offer) => {
	if (!isOfertaV2(oferta)) return getTipoFinanciacionOLD(oferta); // Se puede eliminar cuando ofertasV2 este publicado

	const tipoFinanciacion = oferta.datosEconomicos.filter((d) => d.periodicidad !== 'pago-unico').reduce((prev, curr) => (curr.prioridad > prev.prioridad ? curr : prev), { prioridad: -Infinity } as (typeof oferta.datosEconomicos)[0])?.tipoFinanciacion;

	return formatSlugToTitle(tipoFinanciacion);
};

const createOfferDetails = (oferta: Offer) => {
	if (!isOfertaV2(oferta)) return createOfferDetailsOLD(oferta); // Se puede eliminar cuando ofertasV2 este publicado

	if (!oferta.datosEconomicos?.length) return '';

	return oferta.datosEconomicos
		.map((dato: DatoEconomicoOffer) => {
			const tipo = dato.periodicidad === 'pago-unico' ? 'Precio' : 'Cuota';
			const precio = dato.precio != null ? `${dato.precio} Eur` : '-';
			const periodicidad = dato.periodicidad && dato.periodicidad != 'pago-unico' ? dato.periodicidad : '-';
			const plazos = dato.plazos != null && dato.plazos > 1 ? dato.plazos : '-';
			const entrada = dato.pagoEntrada != null ? `${dato.pagoEntrada} Eur` : '-';
			const final = dato.pagoFinal != null ? `${dato.pagoFinal} Eur` : '-';
			const tin = dato.tin != null ? `TIN: ${dato.tin}%` : '';
			const tae = dato.tae != null ? `TAE: ${dato.tae}%` : '';

			return `${tipo}: ${precio} / \r\n` + `Periodicidad Cuota: ${periodicidad} / \r\n` + `Num Cuotas: ${plazos} / \r\n` + `Entrada: ${entrada} / \r\n` + `Cuota final: ${final}${tin || tae ? '/' : ''}\r\n` + `${tin}${tin && tae ? '/ \r\n' : ''}${tae}`;
		})
		.join('\r\n\r\n'); // separa cada datoEconomico con doble salto de línea
};

const getObservationBrand = (oferta: Offer) => {
	if (!oferta.promociones || oferta.promociones.length === 0) {
		return null;
	}

	return oferta.promociones.map((promo) => promo.name);
};

// Estas funciones OLD se puede eliminar cuando ofertasV2 este publicado
const getTipoFinanciacionOLD = (oferta: Offer) => {
	return oferta.financiacionText?.slice(4);
};
const createOfferDetailsOLD = (oferta: Offer) => {
	return `Cuota: ${oferta.cuota} Eur / \r\nPeriodicidad Cuota: ${oferta.cuotaTipo} / \r\nNum Cuotas: ${oferta.plazos} / \r\nEntrada: ${oferta.cuotaEntrada} Eur / \r\nCuota final: ${oferta.cuotaFinal} Eur ${oferta.tin || oferta.tae ? '/' : ''}\r\n${oferta.tin ? `TIN: ${oferta.tin}% ${oferta.tae ? '/ \r\n' : '\r\n'}` : ''}${oferta.tae ? `TAE: ${oferta.tae}%\r\n` : ''}`;
};
